import { Editor, Element, Node, NodeEntry, Path, Range, Transforms } from 'slate'
import { Registry } from '@react-registry'
import React from 'react'
import { useSlate } from 'slate-react'

import { createCell } from './createCell'
import { elementCategories } from '../../elementCategories'
import { TableAddColumnAboveIcon } from '../../../utils/Icon'
import RTE_SHORTCUT from '../../../../../../../utils/common-rte-utils/shortcuts.constant'
import { cellType, isCellSpanning } from './mergeCells'
import { cloneDeep, findLast } from 'lodash'
import { getSpanningCell } from './helper'
import { incrementColSpan } from './insertColAfter'

export const insertColBefore = (event, { editor }) => {
  const cellEntry = Editor.above(editor, {
    match: (n) => {
      return cellType.includes(n["type"])
    },
    mode: 'lowest'
  })

  const tableEntry = Editor.above(editor, {
    match: (n) => {
      return n["type"] === 'table'
    },
    mode: 'lowest'
  })

  if (!tableEntry || !cellEntry) return

  const colIndex = cellEntry[1].at(-1)

  const cellsInCurrentCol =
    Editor.nodes(editor, {
      at: tableEntry[1],
      match: (n, p) => {
        return cellType.includes(n["type"]) && p.at(-1) === colIndex
      },
      mode: 'lowest'
    })

  const cellsToIncrementColSpanTo: NodeEntry<Node>[] = []

  for (const [cell, path] of cellsInCurrentCol) {
    let isVoid = false

    if (Editor.isVoid(editor, cell)) {

      const spanningCellEntry = getSpanningCell(editor, path)

      if (spanningCellEntry) {
        const [spanningCell,] = spanningCellEntry
        const { hasColSpan } = isCellSpanning(spanningCell)
        if (hasColSpan) {
          cellsToIncrementColSpanTo.push(spanningCellEntry)
          isVoid = true
        }
      }
    }

    let cellToInsert = createCell(cell['type'], isVoid)
    Transforms.insertNodes(editor, cellToInsert, { at: path })

  }

  for (const ne of cellsToIncrementColSpanTo) {
    incrementColSpan(editor, ne)
  }

  let colWidths = tableEntry[0]["attrs"].colWidths.slice()
  colWidths.splice(colIndex, 0, 250)
  Transforms.setNodes(
    editor,
    {
      attrs: {
        ...tableEntry[0]["attrs"],
        colWidths,
        cols: tableEntry[0]["attrs"].cols + 1
      }
    } as Partial<Node>,
    { at: tableEntry[1] }
  )
}

const InsertColBeforeButton = (props) => {
  const editor = useSlate()
  return (
    <React.Fragment>
      {props.children({
        handleMouseDown: insertColBefore,
        isDisable: {
          func: insertColBeforeButtonDisabler,
          params: { editor }
        },
        additionalParams: { editor }
      })}
    </React.Fragment>
  )
}

export const shortcutInsertColBefore = (event, editor, format, registryObj) => {
  insertColBefore(event, { editor })
}

const insertColBeforeButtonDisabler = ({ editor }) => {
  if (editor.selection && Range.isExpanded(editor.selection)) return true

  const [table] = Editor.nodes(editor, {
    match: (n) => {
      return n["type"] === 'table'
    },
    mode: 'lowest'
  })
  return !table
}

Registry.register(
  {
    iconName: <TableAddColumnAboveIcon />,
    IngressComponent: InsertColBeforeButton,
    toolbar: {
      inSlashToolbar: false
    },
    canCustomize: false,
    shortcut: { key: RTE_SHORTCUT.ADD_COLUMN_LEFT, callback: shortcutInsertColBefore },
    category: elementCategories.TABLE_ACTION,
    title: 'Insert column left',
    isContentStackElement: true
  },
  {
    id: 'table-insert-col-before',
    registry: 'element'
  }
)
